// extracted by mini-css-extract-plugin
export var alt = "Brand-module--alt--a54b8";
export var brandImage = "Brand-module--brandImage--abac9";
export var card = "Brand-module--card--52469";
export var cardBody = "Brand-module--cardBody--2b6d3";
export var cardFooter = "Brand-module--cardFooter--557cc";
export var cardImg = "Brand-module--cardImg--444fe";
export var cardText = "Brand-module--cardText--da291";
export var cardTitle = "Brand-module--cardTitle--98939";
export var desktopOnly = "Brand-module--desktopOnly--41293";
export var imgOverlay = "Brand-module--imgOverlay--66367";
export var main = "Brand-module--main--1576a";
export var mobileOnly = "Brand-module--mobileOnly--611a3";
export var textLeft = "Brand-module--textLeft--70238";
export var visuallyHidden = "Brand-module--visuallyHidden--c00ad";